import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui';
import { Button } from '../ui';

interface ConfirmUseCreditModalProps {
  isOpen: boolean;
  onClose: () => void;
  lessonName: string;
  date: string;
  time: string;
  studentName?: string;
  /** Remaining spots for this session (omit for term flows or when unknown) */
  spotsAvailable?: number;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
}

export function ConfirmUseCreditModal({
  isOpen,
  onClose,
  lessonName,
  date,
  time,
  studentName,
  spotsAvailable,
  onConfirm,
  isLoading = false,
}: ConfirmUseCreditModalProps) {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onClose();
    } catch {
      // Error handled by parent
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Confirm make-up booking</DialogTitle>
          <DialogDescription>
            Use your make-up credit to book this lesson?
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 p-4 space-y-2">
          {studentName && (
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
              For: {studentName}
            </p>
          )}
          <p className="font-medium text-gray-900 dark:text-white">{lessonName}</p>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {new Date(date).toLocaleDateString(undefined, {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}{' '}
            at {time}
          </p>
          {spotsAvailable != null && spotsAvailable <= 9990 && (
            <p className="text-xs text-gray-600 dark:text-gray-400">
              {spotsAvailable} spot{spotsAvailable === 1 ? '' : 's'} remaining in this session.
            </p>
          )}
          <p className="text-xs text-gray-500 dark:text-gray-500">
            This will use 1 make-up credit.
          </p>
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? 'Confirming…' : 'Confirm'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
